import { fetchConfiguration, putUserConfiguration } from 'App/api/configurationApi';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useToken } from '../../../store/hooks/useToken';
import { useUserActiveRole } from '../../../store/hooks/useUserActiveRole';
import { QUERY_KEYS } from './queryKeys';

export const useConfigurationQuery = () => {
  const token = useToken();
  const activeRole = useUserActiveRole();
  const organizationShortName = activeRole?.organizationDetails?.shortName;
  const userId = activeRole?.userId;
  const role = activeRole?.role;

  return useQuery({
    queryKey: [QUERY_KEYS.CONFIGURATION, { organizationShortName, userId, role }],
    queryFn: async ({ queryKey }) => {
      const [, queryParams] = queryKey;
      return fetchConfiguration(token, queryParams.organizationShortName, queryParams.userId);
    },
    enabled: !!token && !!activeRole,
  });
};

export const useUpdateUserConfiguration = () => {
  const token = useToken();
  const activeRole = useUserActiveRole();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: configuration => {
      if (!activeRole) {
        throw new Error('Cannot update user configuration without an active role');
      }
      return putUserConfiguration(token, activeRole.organizationDetails.shortName, activeRole.userId, configuration);
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONFIGURATION] }),
  });
};
